import { useState } from 'react';
import clsx from 'clsx';

interface UserAvatarProps {
  photoUrl?: string | null;
  name?: string | null;
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
  className?: string;
}

const sizeClasses = {
  xs: 'h-6 w-6 text-[10px]',
  sm: 'h-8 w-8 text-xs',
  md: 'h-10 w-10 text-sm',
  lg: 'h-12 w-12 text-base',
  xl: 'h-20 w-20 text-2xl',
};

export function UserAvatar({ photoUrl, name, size = 'sm', className }: UserAvatarProps) {
  const [imageError, setImageError] = useState(false);
  const initials = name?.charAt(0)?.toUpperCase() || 'U';

  const showImage = photoUrl && !imageError;

  return (
    <div
      className={clsx(
        'flex items-center justify-center rounded-full overflow-hidden',
        !showImage && 'bg-brand-100 text-brand-700 font-semibold uppercase',
        sizeClasses[size],
        className
      )}
    >
      {showImage ? (
        <img
          src={photoUrl}
          alt={name || 'User'}
          className="h-full w-full object-cover"
          onError={() => setImageError(true)}
        />
      ) : (
        <span>{initials}</span>
      )}
    </div>
  );
}
